import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionAffectedStaffs(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missions.getAffectedStaffs.url, { id }))
    .get<MissionToStaff[]>()
}
